import React, { useEffect, useState } from "react";
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import _axios from "../../httpService";
import ReturnedGoodsFactorData from "./ReturnedGoodsFactorData";
import FactorKol from "./FactorKol/FactorKol";
import FactorJoz from "./FactorJoz/FactorJoz";

const ReturnedGoodsFactor = () => {
  const [sendData, setSendData] = ObjectDataHolder(ReturnedGoodsFactorData.initialSendData);
  console.log("sendData ::", sendData);
  const [initialData, setInitialData] = ObjectDataHolder(ReturnedGoodsFactorData.initialData);
  const [componentData, setComponentData] = ObjectDataHolder(ReturnedGoodsFactorData.componentData);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    _axios.get("https://jsonplaceholder.typicode.com/posts").then((res) => {
    //   setSendData(ReturnedGoodsFactorData.initialSendData);
    //   setInitialData({...ReturnedGoodsFactorData.initialData});
      console.log(ReturnedGoodsFactorData.initialSendData);
    });
  }, []);

  return (
    <div className="counterFactorWrapper__">
      <FactorKol
        sendData={sendData}
        setSendData={setSendData}
        intialData={initialData}
        componentData={componentData}
        setComponentData={setComponentData}
      />
      <div className="tablesWrapper__">
        <FactorJoz
          sendData={sendData}
          setSendData={setSendData}
          initialData={initialData}
          options={initialData.options}
          componentData={componentData}
          setComponentData={setComponentData}
        />
      </div>
    </div>
  );
};

export default ReturnedGoodsFactor;
